if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          form: "form",
          inputId: "[name=id]",
          submitButton: '[name="add"]',
          errorWrapper: ".f-product-form__error-message-wrapper",
          customFields: ["[data-product-custom-field]"],
          customCartButton: "[data-custom-atc]",
          customQuickView: "[data-custom-atc-qv]"
        };

        this.domNodes = queryDomNodes(this.selectors, this);

        this.form = this.domNodes.form;
        this.submitButton = this.domNodes.submitButton;
        this.domNodes.inputId.disabled = false;
        this.Notification = window.FoxTheme.Notification;
        this.notificationType = this.dataset.notificationType;
        this.customFields = document.querySelectorAll(
          this.selectors.customFields
        );
        this.cartDrawer = document.querySelector("cart-drawer");
        this.mainCart = document.querySelector("cart-items");
        this.type = this.dataset.type;

        this.variantIdInput = this.domNodes.inputId;
        this.errorWrapperHideTimeoutId = null;

        this.errorWrapper =
          this.type === "product-card"
            ? this.closest(".product-card")
            : this.domNodes.errorWrapper;

        this.boundSubmitHandler = this.onSubmitHandler.bind(this);
        this.boundStringingChangeHandler = this.handleStringingChange.bind(this);
        this.isSubmitting = false;
        this.stringingSelectListeners = new Map();
        this.customButtonHandlers = new Map();

        this.customCartButton = this.querySelector(
          this.selectors.customCartButton
        );

        if (this.customCartButton) {
          const clickHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.boundSubmitHandler(e);
          };

          this.customCartButton.addEventListener("click", clickHandler, true);
          this.customButtonHandlers.set(this.customCartButton, clickHandler);

          if (this.form) {
            const formSubmitBlocker = (e) => {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              return false;
            };
            this.form.addEventListener("submit", formSubmitBlocker, true);
            this.customButtonHandlers.set(this.form, formSubmitBlocker);
          }
        } else if (this.form) {
          this.form.addEventListener("submit", this.boundSubmitHandler);
        }

        this.customQuickView = this.querySelector(
          this.selectors.customQuickView
        );
        if (this.customQuickView) {
          const clickHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.form && e.target.closest('form') === this.form) {
              e.stopImmediatePropagation();
            }
            this.boundSubmitHandler(e);
          };
          this.customQuickView.addEventListener("click", clickHandler);
          this.customButtonHandlers.set(this.customQuickView, clickHandler);
        }

        const stringingSelects = this.querySelectorAll('#stringing-options, #string-tightness, #logo-color');
        if (stringingSelects && stringingSelects.length > 0) {
          stringingSelects.forEach(select => {
            select.addEventListener('change', this.boundStringingChangeHandler);
            this.stringingSelectListeners.set(select, this.boundStringingChangeHandler);
          });
        }
      
      }

      disconnectedCallback() {
        if (this.form && this.boundSubmitHandler) {
          this.form.removeEventListener("submit", this.boundSubmitHandler);
        }

        this.customButtonHandlers.forEach((handler, element) => {
          element.removeEventListener("click", handler);
          element.removeEventListener("submit", handler);
        });
        this.customButtonHandlers.clear();

        this.stringingSelectListeners.forEach((handler, select) => {
          select.removeEventListener('change', handler);
        });
        this.stringingSelectListeners.clear();

        this.isSubmitting = false;
      }

      handleStringingChange() {
        const productwrapper = this.closest('product-info') || this.closest('.qv-product-info')?.closest('.product-title-info');
        const validationMessageEl = productwrapper?.querySelector('#stringing-validation-message');
        if (validationMessageEl) {
          let filledCount = 0;
          let totalFields = 0;

          if (productwrapper.querySelector('.dropdown-container')) {
            productwrapper.querySelectorAll('.dropdown-container select').forEach((each) => {
              totalFields += 1;
              if (each.value && each.value !== '') {
                filledCount += 1;
              }
            });
          }

          if (filledCount === totalFields && totalFields > 0) {
            validationMessageEl.style.display = 'none';
          } else if (filledCount > 0 && filledCount < totalFields) {
            const validationMessage = validationMessageEl.getAttribute('data-validation-message');
            const iconTemplate = document.querySelector('#validation-warning-icon-template');
            const iconHTML = iconTemplate ? iconTemplate.innerHTML : '';
            validationMessageEl.innerHTML = `${iconHTML}<span>${validationMessage}</span>`;
            validationMessageEl.style.display = 'flex';
          } else {
            validationMessageEl.style.display = 'none';
          }
        }
      }

      getStringingPropertyNames() {
        let propertyNames = {
          logoColor: 'Logo Color',
          stringTension: 'String Tension'
        };
        try {
          const propertiesScript = document.querySelector('#stringing-service-properties');
          if (propertiesScript) {
            const parsed = JSON.parse(propertiesScript.textContent);
            propertyNames.logoColor = parsed.logoColorProperty || propertyNames.logoColor;
            propertyNames.stringTension = parsed.stringTensionProperty || propertyNames.stringTension;
          }
        } catch (e) {
          console.warn('Failed to parse stringing service properties:', e);
        }
        return propertyNames;
      }

      hasStringingSelectValue(select) {
        if (select.id === 'logo-color') {
          if (select.selectedIndex > 0 && select.options[select.selectedIndex]) {
            const selectedOption = select.options[select.selectedIndex];
            return selectedOption.textContent.trim() !== '' &&
              selectedOption.value !== '' &&
              !selectedOption.textContent.includes('Select') &&
              !selectedOption.textContent.includes('Chọn');
          }
          return false;
        }
        return select.value && select.value.trim() !== '';
      }

      scheduleErrorWrapperHide(wrapper, delay = 3600) {
        if (!wrapper) return;
        clearTimeout(this.errorWrapperHideTimeoutId);
        this.errorWrapperHideTimeoutId = setTimeout(() => {
          wrapper.style.display = "none";
        }, delay);
      }

      validateForm(form) {
        const missingFields = [];
        if (!form) return missingFields;
        const fieldSelectors =
          '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])';
        const requiredFields = form.querySelectorAll(fieldSelectors);
        requiredFields.forEach((field) => {
          field.classList.remove("form-control--warning");
          if (field.type === "radio") {
            const buttons = form.querySelectorAll(
              `input[name="${field.name}"]`
            );
            const selected = Array.from(buttons).some((btn) => btn.checked);
            if (!selected) {
              missingFields.push(field);
              field.classList.add("form-control--warning");
            }
          } else if (!field.value) {
            missingFields.push(field);
            field.classList.add("form-control--warning");
          }
        });
        return missingFields;
      }

      onSubmitHandler(evt) {
        if (this.isSubmitting === true) {
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();
          return false;
        }

        if (this.submitButton && this.submitButton.classList.contains("btn--loading")) {
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();
          return false;
        }

        this.isSubmitting = true;

      let productwrapper = evt.target.closest('product-info');
      if (
        productwrapper?.classList.contains('custom-available') && productwrapper.querySelector('#stringing-options')?.selectedIndex
      ) {
        let mainProductInCartQuantity = 0;
        let stringCartQuantity = 0;
        let onlyMainProduct = false;
        let onlyStringProduct = false;

        let variantPickerInput = productwrapper.querySelector('.variant-picker__field.size-field .variant-picker__option input[checked]');
        let mainProductTotalAvailableQuantity = 0;
        let mainProductVariantId = null;

        if (variantPickerInput) {
          mainProductTotalAvailableQuantity = Number(variantPickerInput.getAttribute('data-variantavailable') || 0);
          mainProductVariantId = variantPickerInput.getAttribute('data-variantid');
        }

        let stringTotalAvailableQuantity;
        let stringVariantId;

        if(productwrapper.querySelector('#stringing-options')?.selectedIndex){
          let select = productwrapper.querySelector("#stringing-options");
          let selectedOption = select.options[select.selectedIndex];
          if (selectedOption) {
            stringTotalAvailableQuantity = Number(selectedOption.getAttribute("data-available") || 0);
            stringVariantId = selectedOption.value;
          }
        }

        if(mainProductVariantId && document.querySelector('#CartDrawer')){
          document.querySelectorAll('.f-cart-drawer__item').forEach((each)=>{
            if(each.getAttribute('data-cart-item-variant-id') == mainProductVariantId){
              mainProductInCartQuantity += Number(each.querySelector('.f-quantity__wrapper .f-quantity__input')?.value || 0)
            }
            if(stringVariantId && each.getAttribute('data-cart-item-variant-id') == stringVariantId){
              stringCartQuantity += Number(each.querySelector('.f-quantity__wrapper .f-quantity__input')?.value || 0)
            }
          })
        }else{
          mainProductInCartQuantity = 0;
          stringCartQuantity = 0;
        }

        if(mainProductTotalAvailableQuantity > 0 && mainProductTotalAvailableQuantity <= mainProductInCartQuantity){
          onlyMainProduct = true;
        }
        if (productwrapper.querySelector('#stringing-options')?.selectedIndex){
          if(stringTotalAvailableQuantity && stringTotalAvailableQuantity <= stringCartQuantity){
            onlyStringProduct = true;
          }
        }

        // console.log('229', onlyMainProduct, onlyStringProduct)
        if(onlyMainProduct || onlyStringProduct){
          const errorWrapper = productwrapper.querySelector('.f-product-form__error-message-wrapper');
          if (errorWrapper) {
            errorWrapper.style.display = "block"; 
          }
          
          this.Notification.show({
            target: errorWrapper,
            method: "appendChild",
            type: "warning",
            message: "Cannot add more items to the cart. Maximum quantity reached.",
            last: 3000,
            sticky: this.notificationType === "toast",
          });
          this.scheduleErrorWrapperHide(errorWrapper);
          this.isSubmitting = false;
          return 
        }
      }
        evt.preventDefault();
        const missing = this.validateForm(
          this.form.closest(".f-product-single__blocks")
        );

        if (missing && missing.length > 0) {
          this.isSubmitting = false;
          if (this.domNodes.errorWrapper) this.domNodes.errorWrapper.style.display = "block";
          this.scheduleErrorWrapperHide(this.domNodes.errorWrapper);
          return this.Notification.show({
            target: this.domNodes.errorWrapper,
            method: "appendChild",
            type: "warning",
            message: window.FoxThemeStrings.requiredField,
          });
        }

        if(this.submitButton){
         if (this.submitButton.classList.contains("btn--loading")) {
          this.isSubmitting = false;
          return;
         }

          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("btn--loading");
          
        }
        const config = {
          method: "POST",
          headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
        };

      // const formData = new FormData(this.form);

      //Check if customisation available with product****************************
        // Check if customisation is available
        if (
          (evt.target.closest('.product-title-info')?.classList.contains('custom-available')) || (evt.target.closest('.qv-product-info')?.classList.contains('custom-available') )
        ) {
          let counter = 0;
          let numberOfSelectOption = 0;
          
          if (productwrapper.querySelector('.dropdown-container')) {
            productwrapper.querySelectorAll('.dropdown-container select').forEach((each, index) => {
              if (this.hasStringingSelectValue(each)) {
                counter += 1;
              }
              numberOfSelectOption = index + 1;
            });
          }

          // Main product
          let main_prod_id = productwrapper.querySelector('product-form input[name="id"]').value;
          let main_prod_name = productwrapper.querySelector('.f-product-single__title.h2').innerHTML;
          

          if (counter === numberOfSelectOption) {
            const validationMessageEl = productwrapper.querySelector('#stringing-validation-message');
            if (validationMessageEl) {
              validationMessageEl.style.display = 'none';
            }

            let formDataCustom = new FormData();
            let stringOptionElement = productwrapper.querySelector("#stringing-options");
            let stringOption = stringOptionElement?.value;
            let logoColor =  productwrapper.querySelector("#logo-color")?.value;
            let logoColorFormatted = logoColor ? logoColor.trim().split(' ').join('') : '';
            let stringTightness =  productwrapper.querySelector("#string-tightness")?.value;
            let freestring_lineitem = stringOptionElement?.getAttribute('data-line-item');
            
            let selectedOption = stringOptionElement?.options[stringOptionElement.selectedIndex];
            let stringPrice =  selectedOption ? selectedOption.getAttribute("data-price") : '';
            let stringType = selectedOption ? selectedOption.getAttribute("data-string-type") : "paid";

            let serviceChargeProductVarId = Number(productwrapper.querySelector('#service-charge-details')?.getAttribute('data-varid'));
            let unique_key = `${main_prod_id}-${selectedOption?.value}-${serviceChargeProductVarId}-${stringTightness}-${logoColorFormatted}`;

            const propertyNames = this.getStringingPropertyNames();

            // Stringing service product (if applicable)
            let stringServiceCharge = productwrapper.querySelector('#service-charge-details')?.getAttribute('data-service-product');
            let serviceCharge = productwrapper.querySelector('#service-charge-details').getAttribute('data-stringing-charge');

            let itemIndex = 0;
            
            if (stringServiceCharge !== 'none') {
              formDataCustom.append(`items[${itemIndex}][id]`, stringServiceCharge);
              formDataCustom.append(`items[${itemIndex}][quantity]`, 1);
              formDataCustom.append(`items[${itemIndex}][properties][_unique_id]`, unique_key);
              formDataCustom.append(`items[${itemIndex}][properties][_product_type]`, 'CustomAddon');
              formDataCustom.append(`items[${itemIndex}][properties][_custom_product_name]`, 'StringService');
              formDataCustom.append(`items[${itemIndex}][properties][_Product]`, main_prod_name);
              if (logoColor) formDataCustom.append(`items[${itemIndex}][properties][${propertyNames.logoColor}]`, logoColor);
              if (stringTightness) formDataCustom.append(`items[${itemIndex}][properties][${propertyNames.stringTension}]`, stringTightness);
              itemIndex++;
            } 

            // Additional string product (if selected)
            if (stringOption) {
              formDataCustom.append(`items[${itemIndex}][id]`, stringOption);
              formDataCustom.append(`items[${itemIndex}][quantity]`, 1);
              formDataCustom.append(`items[${itemIndex}][properties][_unique_id]`, unique_key);
              formDataCustom.append(`items[${itemIndex}][properties][_product_type]`, 'CustomAddon');
              formDataCustom.append(`items[${itemIndex}][properties][_custom_product_name]`, 'StringSelected');
              formDataCustom.append(`items[${itemIndex}][properties][_Product]`, main_prod_name);
              if (stringType === "free") {
                if (freestring_lineitem !== "") {
                  formDataCustom.append(`items[${itemIndex}][properties][_free_string]`, freestring_lineitem);
                } else {
                  formDataCustom.append(`items[${itemIndex}][properties][String Price]`, stringType);
                }
              }
              itemIndex++;
            }

            formDataCustom.append(`items[${itemIndex}][id]`, main_prod_id);
            formDataCustom.append(`items[${itemIndex}][quantity]`, 1);
            formDataCustom.append(`items[${itemIndex}][properties][_unique_id]`, unique_key);
            formDataCustom.append(`items[${itemIndex}][properties][_product_type]`, "MainProduct");
            formDataCustom.append(`items[${itemIndex}][properties][_string_product_price]`, stringPrice);
            formDataCustom.append(`items[${itemIndex}][properties][_stringing_service_charge]`, serviceCharge);

            config.body = formDataCustom;
          }
          else{
            if (counter > 0 && counter < numberOfSelectOption) {
              const validationMessageEl = productwrapper.querySelector('#stringing-validation-message');
              if (validationMessageEl) {
                const validationMessage = validationMessageEl.getAttribute('data-validation-message');
                const iconTemplate = document.querySelector('#validation-warning-icon-template');
                const iconHTML = iconTemplate ? iconTemplate.innerHTML : '';
                validationMessageEl.innerHTML = `${iconHTML}<span>${validationMessage}</span>`;
                validationMessageEl.style.display = 'flex';
                validationMessageEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                if(this.submitButton){
                  this.submitButton.classList.remove("btn--loading");
                  this.submitButton.removeAttribute("aria-disabled");
                }
              }
              this.isSubmitting = false;
              return;
            }

            const validationMessageEl = productwrapper.querySelector('#stringing-validation-message');
            if (validationMessageEl) {
              validationMessageEl.style.display = 'none';
            }

            let formDataCustom = new FormData();
            formDataCustom.append("items[0][id]", main_prod_id);
            formDataCustom.append("items[0][quantity]", 1);
            config.body = formDataCustom;
          }
         
        } 
        else {
          // Default add to cart flow
          let formDataDefault = new FormData(this.form);
          config.body = formDataDefault;
        }

      //End of customisation code************************************************


        if (this.cartDrawer) {
          config.body.append(
            "sections",
            this.cartDrawer.getSectionsToRender().map((section) => section.id)
          );
        }

        if (this.mainCart) {
          config.body.append(
            "sections",
            this.mainCart
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }

        if (this.mainCart || this.cartDrawer) {
          config.body.append("sections_url", window.location.pathname);
        }

        async function updateDrawer() {
          let response = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
          let result = await response.text();
          const html = new DOMParser().parseFromString(result, 'text/html');
          
          const newCartDrawer = html.querySelector('#Drawer-Cart');
          newCartDrawer ? document.querySelector("#Drawer-Cart").innerHTML = newCartDrawer.innerHTML : '';
          document.querySelector('drawer-opener[data-drawer="#Drawer-Cart"] a').click();

        }

        // config.body = formData; 
        const { FoxThemeSettings, FoxThemeStrings } = window;
        fetch(`${FoxThemeSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if(response.status == '422'){
                if(!response.message.includes('The maximum quantity of this item is already in your cart'))
                updateDrawer();
                FoxThemeCartHelpers.getState().then((state) => {
                  FoxThemeCartHelpers.updateCartCount(state.item_count);
                });
              }

              window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: config.body.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.error = true;
              if (this.errorWrapper) this.errorWrapper.style.display = "block";
              this.scheduleErrorWrapperHide(this.errorWrapper);
              return this.Notification.show({
                target:
                  this.notificationType === "toast"
                    ? document.body
                    : this.errorWrapper,
                method: "appendChild",
                type: "warning",
                message: response.description || response.message,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }

            if (
              !FoxThemeSettings.cart.openDrawerWhenAdded ||
              FoxThemeSettings.cart.cartType === "page"
            ) {
              this.Notification.show({
                target: this.errorWrapper,
                method: "appendChild",
                type: "success",
                message: FoxThemeStrings.item_added,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }
            if (FoxThemeSettings.cart.cartType === "page") {
              FoxThemeCartHelpers.getState().then((state) => {
                FoxThemeCartHelpers.updateCartCount(state.item_count);
              });
            }

            this.error = false;
            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.isSubmitting = false;
            if(this.submitButton){
              this.submitButton.classList.remove("btn--loading");
              this.submitButton.removeAttribute("aria-disabled");
            }
          });
      }
    }
  );
}
